(() => {
  'use strict';

  const isResultsPage = /^\/(?:[^/]+\/)?(?:collections(?:\/|$)|search(?:\/|$))/.test(
    window.location.pathname
  );

  if (!isResultsPage) return;

  const heldText = 'Afholdt';
  const eventProductPaths = new Set();
  const pastProductPaths = new Set();
  let usfHooksRegistered = false;

  const normalizeProductPath = (href) => {
    if (!href) return '';

    try {
      const path = new URL(href, window.location.origin).pathname.replace(/\/$/, '');
      return path.includes('/products/') ? path : '';
    } catch (error) {
      return '';
    }
  };

  const getCardProductPath = (card) => {
    if (card.matches('a[href*="/products/"]')) {
      return normalizeProductPath(card.getAttribute('href'));
    }

    const productLink = card.querySelector('a[href*="/products/"]');
    return normalizeProductPath(productLink && productLink.getAttribute('href'));
  };

  const isPastCard = (card) => pastProductPaths.has(getCardProductPath(card));

  const createHeldButton = (className, labelClass) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `${className} event-button--held`;
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');

    const label = document.createElement('span');
    if (labelClass) label.className = labelClass;
    label.textContent = heldText;
    button.appendChild(label);

    return button;
  };

  const lockPurchaseForm = (form) => {
    const isQuickAdd = Boolean(form.closest('.quick-add'));
    const className = isQuickAdd
      ? 'quick-add__submit button button--full-width button--secondary'
      : 'usf-add-to-cart-btn';
    const labelClass = isQuickAdd ? '' : 'usf-label';

    form.replaceChildren(createHeldButton(className, labelClass));
    form.dataset.brogEventLocked = 'true';
  };

  const setHeldBadges = (card) => {
    const badgeContainers = card.querySelectorAll('.card__badge');

    badgeContainers.forEach((container) => {
      const badge = document.createElement('span');
      badge.className = 'badge badge--bottom-left event-status-badge--held';
      badge.textContent = heldText;
      container.replaceChildren(badge);
    });

    if (badgeContainers.length > 0) return;

    const imageWrapper = card.querySelector('.usf-img-wrapper');
    if (!imageWrapper) return;

    let listBadge = imageWrapper.querySelector('.usf-badge');
    if (!listBadge) {
      listBadge = document.createElement('div');
      listBadge.className = 'usf-badge';
      imageWrapper.appendChild(listBadge);
    }

    const label = document.createElement('span');
    label.textContent = heldText;
    listBadge.classList.remove('usf-sale-badge');
    listBadge.replaceChildren(label);
  };

  const lockCard = (card) => {
    if (!isPastCard(card)) return;

    card.dataset.brogPastEvent = 'true';
    card.classList.add('event-card--past');
    setHeldBadges(card);

    card.querySelectorAll('form.usf-add-to-cart').forEach(lockPurchaseForm);

    card.querySelectorAll('.quick-add').forEach((quickAdd) => {
      if (quickAdd.dataset.brogEventLocked === 'true') return;

      quickAdd.replaceChildren(
        createHeldButton('quick-add__submit button button--full-width button--secondary', '')
      );
      quickAdd.dataset.brogEventLocked = 'true';
    });
  };

  const prioritizeUpcomingEvents = () => {
    document.querySelectorAll('.usf-results.usf-grid').forEach((resultsGrid) => {
      const cards = Array.from(resultsGrid.children).filter((child) =>
        child.classList.contains('usf-sr-product')
      );

      if (cards.length === 0) return;

      const containsOnlyEvents = cards.every((card) => {
        const productPath = getCardProductPath(card);
        return productPath && eventProductPaths.has(productPath);
      });

      cards.forEach((card) => {
        if (containsOnlyEvents) {
          card.style.order = isPastCard(card) ? '1' : '0';
        } else {
          card.style.removeProperty('order');
        }
      });
    });
  };

  const scanCards = () => {
    document.querySelectorAll('.usf-sr-product').forEach(lockCard);
    prioritizeUpcomingEvents();
  };

  const scheduleScan = () => {
    window.setTimeout(scanCards, 0);
    window.setTimeout(scanCards, 400);
  };

  const registerUsfHooks = () => {
    if (usfHooksRegistered) return true;
    if (!window.usf || !window.usf.event || typeof window.usf.event.add !== 'function') return false;

    window.usf.event.add(['sr_updated', 'sr_viewChanged', 'rerender'], scheduleScan);
    usfHooksRegistered = true;
    scheduleScan();
    return true;
  };

  const waitForUsf = () => {
    if (registerUsfHooks()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (registerUsfHooks() || attempts >= 150) window.clearInterval(timer);
    }, 100);
  };

  const loadPastProductPaths = async () => {
    const shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const collectionUrl = new URL(`${shopRoot}collections/arrangementer`, window.location.origin);

    try {
      const response = await window.fetch(collectionUrl.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) return;

      const html = await response.text();
      const collectionDocument = new DOMParser().parseFromString(html, 'text/html');

      collectionDocument.querySelectorAll('.events-collection a[href*="/products/"]').forEach((productLink) => {
        const path = normalizeProductPath(productLink.getAttribute('href'));
        if (path) eventProductPaths.add(path);
      });

      collectionDocument.querySelectorAll('.event-card--past').forEach((pastCard) => {
        pastCard.querySelectorAll('a[href*="/products/"]').forEach((productLink) => {
          const path = normalizeProductPath(productLink.getAttribute('href'));
          if (path) pastProductPaths.add(path);
        });
      });

      scheduleScan();
    } catch (error) {
      // The filter remains fully usable if the events lookup temporarily fails.
    }
  };

  const getRelatedCard = (element) => {
    const card = element.closest('.usf-sr-product');
    if (card) return card;

    const preview = element.closest('[id^="preview-modal-"]');
    if (!preview) return null;

    const productId = preview.id.replace('preview-modal-', '');
    return document.querySelector(`.usf-sr-product[data-usf-pid="${productId}"]`);
  };

  const blockPastEventPurchase = (event) => {
    if (!(event.target instanceof Element)) return;

    const control =
      event.type === 'submit'
        ? event.target
        : event.target.closest('.usf-add-to-cart-btn, .quick-add__submit, usf-choose-options');

    if (!control) return;

    const card = getRelatedCard(control);
    if (!card || card.dataset.brogPastEvent !== 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
  };

  document.addEventListener('click', blockPastEventPurchase, true);
  document.addEventListener('submit', blockPastEventPurchase, true);

  waitForUsf();
  loadPastProductPaths();
})();